module.exports = __webpack_public_path__ + "CreativeDirection27.png?e4394f2c1069d9f9b103493f6a925fe5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CreativeDirection27.png
// module id = 39
// module chunks = 0